import { Attach } from '@/components';
import { useAppClippo } from '@/core';
import { useClippoBlobs } from '@/utils';
import { Row, Typography } from 'antd';
import { useGetPersonalizationItemsQuery } from '@/redux';
import { Trans, useTranslation } from 'react-i18next';
import styles from './HomePersonalizationAttachmentsPanel.module.scss';

interface Props {
  homeId: string;
  projectId: string;
  className?: string;
}

const { Text } = Typography;

export const HomePersonalizationAttachmentsPanel = (props: Props) => {
  const { homeId, projectId, className } = props;
  const { data: personalizationItems } = useGetPersonalizationItemsQuery({
    homeId,
    projectId,
  });

  const { t } = useTranslation();

  if (!personalizationItems?.length) {
    return null;
  }

  return (
    <div className={className}>
      <Row>
        <Text className={styles.color}>
          <Trans
            i18nKey={t('personalization.attachments.title')}
            components={{ strong: <strong />, italic: <em /> }}
          />
        </Text>
      </Row>

      {personalizationItems.map((item) => (
        <ItemAttachment
          key={item.id}
          itemId={item.id}
          itemName={item.name}
          number={item.number}
        />
      ))}
    </div>
  );
};

interface ItemProps {
  itemId: string;
  itemName: string;
  number?: number;
}

function ItemAttachment(props: ItemProps) {
  const { itemId, itemName, number } = props;

  const clippoProps = useAppClippo({
    defer: false,
    ownerId: itemId,
    ownerType: 'PersonalizationAttachments',
  });

  const clippoBlobs = useClippoBlobs(clippoProps);

  if (!clippoBlobs.blobs?.length) {
    return null;
  }

  return (
    <div className="mt-3">
      <Text className={styles.color} strong italic>
        {itemName}
        {number != null && ` (${number})`}:
      </Text>

      <Attach
        {...clippoProps}
        showAdd={false}
        multiple
        blobs={clippoBlobs.blobs}
        showActions
        openOnClick={false}
      />
    </div>
  );
}
